import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useParams } from 'react-router'
import { getUsers } from 'services/withDraw'
interface IUser extends IWithDrawUser {
    isSelected: boolean
}
interface ISelectUser {
    name: string
    id: undefined | number
    memberId: undefined | number
}
export default function useGetUsers(
    setSelect: React.Dispatch<React.SetStateAction<ISelectUser | undefined>>,
    searchTransaction: string
) {
    const [users, setUsers] = useState<undefined | Array<IUser>>()
    const { id } = useParams()
    const { data, isLoading } = useQuery(
        ['with-draw-select-modal-users', id, searchTransaction],
        getUsers
    )
    useEffect(() => {
        if (data && !isLoading) {
            const newUsers: Array<IUser> = []
            data.results.map((item, index) =>
                newUsers.push({
                    ...item,
                    ...(index === 0
                        ? { isSelected: false }
                        : { isSelected: false }),
                })
            )
            setUsers(newUsers)
        }
    }, [data])
    const handleSelect = (id: number) => {
        const newUsers: Array<IUser> = []
        users?.map((item) => {
            if (item.id === id) {
                newUsers.push({ ...item, isSelected: true })
            } else {
                newUsers.push({ ...item, isSelected: false })
            }
        })
        setUsers(newUsers)
    }
    return { data: users, isLoading, handleSelect }
}
